import type { CSSProperties } from 'react';
import { COLOR, fontFamily } from '../manage-course-plan/manage-course-plan.styles';
export {
  bottomActionsWrapStyle,
  saveErrorTextStyle,
} from '../shared/components/add-page-bottom-bar.styles';

export const pageStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  fontFamily,
};

export const topBarStyle: CSSProperties = {
  minHeight: 30,
  padding: '15px 24px 0px',
};

export const breadcrumbNavStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 13,
  color: COLOR.textMuted,
  fontFamily,
};

export const breadcrumbBtnStyle: CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: COLOR.linkBlue,
  fontSize: 13,
  fontFamily,
  padding: 0,
};

export const scrollableStyle: CSSProperties = {
  flex: 1,
  overflow: 'auto',
  padding: '16px 24px 100px',
};

export const pageTitleRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  marginBottom: 6,
};

export const h1Style: CSSProperties = {
  fontSize: 22,
  fontWeight: 700,
  color: COLOR.textPrimary,
  fontFamily,
  margin: 0,
};

export const infoIconBtnStyle: CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '2px 4px',
  borderRadius: 4,
  color: COLOR.textMuted,
  display: 'flex',
  alignItems: 'center',
};

export const metaRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 20,
  flexWrap: 'wrap',
};

export const metaItemStyle: CSSProperties = {
  fontSize: 14,
  color: COLOR.textSecondary,
  fontFamily,
};

export const metaLabelStyle: CSSProperties = { color: COLOR.textMuted };

export const descStyle: CSSProperties = {
  fontSize: 14,
  color: COLOR.textSecondary,
  fontFamily,
  marginBottom: 4,
};

export const subheadStyle: CSSProperties = {
  fontSize: 14,
  color: COLOR.textBody,
  fontFamily,
  margin: 0,
};

export const metaAndSubheadRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 24,
  marginBottom: 20,
  flexWrap: 'wrap',
};

export const twoColStyle: CSSProperties = {
  display: 'flex',
  gap: 24,
  alignItems: 'flex-start',
};

export const leftColStyle: CSSProperties = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
};

export const rightColStyle: CSSProperties = {
  width: 320,
  flexShrink: 0,
  position: 'sticky',
  top: 0,
};

export const listCardStyle: CSSProperties = {
  backgroundColor: COLOR.white,
  borderRadius: 8,
  boxShadow: '0px 1px 4px rgba(0,0,0,0.08)',
  overflow: 'hidden',
  display: 'flex',
};

export const listSidebarStyle: CSSProperties = {
  width: 256,
  flexShrink: 0,
  padding: 24,
  borderRight: `1px solid ${COLOR.border}`,
};

export const listNumberStyle: CSSProperties = {
  fontSize: 18,
  fontWeight: 600,
  color: COLOR.textPrimary,
  fontFamily,
  marginBottom: 8,
};

export const listInstructionStyle: CSSProperties = {
  fontSize: 14,
  color: COLOR.textMuted,
  fontFamily,
  lineHeight: 1.5,
};

export const listBodyStyle: CSSProperties = {
  flex: 1,
  minWidth: 0,
  padding: 24,
};

export const searchRowStyle: CSSProperties = {
  display: 'flex',
  gap: 8,
  marginBottom: 16,
  alignItems: 'center',
};

export const filterDropdownWrapStyle: CSSProperties = {
  flexShrink: 0,
};

export const searchInputWrapStyle: CSSProperties = {
  flex: 1,
  minWidth: 0,
};

export const searchInputStyle: CSSProperties = {
  width: '100%',
  height: 32,
  paddingLeft: 32,
  paddingRight: 10,
  border: `1px solid ${COLOR.borderMedium}`,
  borderRadius: 4,
  fontSize: 13,
  fontFamily,
  color: COLOR.textPrimary,
  backgroundColor: COLOR.white,
  outline: 'none',
  boxSizing: 'border-box',
};

export const searchIconWrapStyle: CSSProperties = {
  position: 'absolute',
  left: 8,
  top: '50%',
  transform: 'translateY(-50%)',
  color: COLOR.textMuted,
  pointerEvents: 'none',
  display: 'flex',
};

export const coursesListStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
};

export const addCourseBtnStyle: CSSProperties = {
  height: 32,
  paddingLeft: 10,
  paddingRight: 12,
  border: `1px solid ${COLOR.borderMedium}`,
  borderRadius: 4,
  backgroundColor: COLOR.white,
  color: '#00427C',
  fontFamily,
  fontSize: 13,
  fontWeight: 500,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

export const gradeSelectorBtnStyle: CSSProperties = {
  height: 32,
  paddingLeft: 10,
  paddingRight: 8,
  border: `1px solid ${COLOR.borderMedium}`,
  borderRadius: 4,
  backgroundColor: COLOR.white,
  color: COLOR.textPrimary,
  fontFamily,
  fontSize: 13,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
};

export const gradeSelectorCheckStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 16,
  height: 16,
  borderRadius: '50%',
  backgroundColor: COLOR.selectionCheckGreen,
  color: '#fff',
  fontSize: 10,
  fontWeight: 900,
  flexShrink: 0,
  lineHeight: 1,
};

export const removeCourseBtnStyle: CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '4px',
  color: COLOR.textMuted,
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
};

export const gradePopoverStyle: CSSProperties = {
  position: 'fixed',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: COLOR.white,
  border: `1px solid ${COLOR.border}`,
  borderRadius: 6,
  boxShadow: '0px 4px 12px rgba(0,0,0,0.12)',
  zIndex: 1000,
  minWidth: 130,
  padding: '4px 0',
};

export const gradeOptionBtnStyle: CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '8px 16px',
  background: 'none',
  border: 'none',
  textAlign: 'left',
  fontSize: 14,
  color: COLOR.textPrimary,
  fontFamily,
  cursor: 'pointer',
};

export const multiGradePopoverHeadingStyle: CSSProperties = {
  padding: '10px 16px 6px',
  fontSize: 13,
  fontWeight: 600,
  color: COLOR.textSecondary,
  fontFamily,
};

export const multiGradeCheckRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '6px 16px',
  fontSize: 14,
  color: COLOR.textPrimary,
  fontFamily,
};

export const multiGradeAddBtnWrapStyle: CSSProperties = {
  padding: '8px 16px 12px',
};

export const multiGradeConfirmBtnStyle: CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '10px 0',
  backgroundColor: COLOR.linkBlue,
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  fontSize: 14,
  fontWeight: 500,
  fontFamily,
  cursor: 'pointer',
};

export const multiGradeConfirmBtnDisabledStyle: CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '10px 0',
  backgroundColor: '#B0BBD5',
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  fontSize: 14,
  fontWeight: 500,
  fontFamily,
  cursor: 'not-allowed',
};

export const andSeparatorStyle: CSSProperties = {
  padding: '24px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const andSeparatorLeftStyle: CSSProperties = {
  padding: '24px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
};

export const andLineStyle: CSSProperties = {
  flex: 1,
  height: 1,
  backgroundColor: '#E5E7EB',
};

export const andBadgeStyle: CSSProperties = {
  fontSize: 14,
  fontWeight: 600,
  color: '#374151',
  fontFamily,
  padding: '8px 16px',
  borderRadius: 4,
};

export const scheduleCardStyle: CSSProperties = {
  backgroundColor: COLOR.white,
  borderRadius: 8,
  boxShadow: '0px 1px 4px rgba(0,0,0,0.08)',
  overflow: 'hidden',
};

export const scheduleHeaderStyle: CSSProperties = {
  backgroundColor: '#00427C',
  color: COLOR.white,
  padding: '14px 16px',
};

export const scheduleHeaderTitleStyle: CSSProperties = {
  fontSize: 14,
  fontWeight: 600,
  fontFamily,
  marginBottom: 8,
};

export const creditBarWrapStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
};

export const creditBarTrackStyle: CSSProperties = {
  flex: 1,
  height: 8,
  backgroundColor: 'rgba(255,255,255,0.3)',
  borderRadius: 4,
  overflow: 'hidden',
};

export const creditBarTextStyle: CSSProperties = {
  fontSize: 12,
  fontFamily,
  color: 'rgba(255,255,255,0.9)',
  whiteSpace: 'nowrap',
};

export const scheduleBodyStyle: CSSProperties = {
  padding: '16px',
};

export const gradeGroupStyle: CSSProperties = {
  marginBottom: 14,
};

export const gradeHeadingStyle: CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: COLOR.textSecondary,
  fontFamily,
  marginBottom: 6,
};

export const scheduleCourseMiniStyle: CSSProperties = {
  border: `1px solid ${COLOR.border}`,
  borderRadius: 8,
  padding: '10px 12px',
  marginBottom: 6,
  backgroundColor: COLOR.white,
};

export const scheduleCourseNameStyle: CSSProperties = {
  fontSize: 13,
  fontWeight: 500,
  color: COLOR.linkBlue,
  fontFamily,
  marginBottom: 2,
};

export const scheduleCourseNameBtnStyle: CSSProperties = {
  fontSize: 13,
  fontWeight: 500,
  color: COLOR.linkBlue,
  fontFamily,
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  textAlign: 'left',
  flex: 1,
  minWidth: 0,
};

export const scheduleCourseTopRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 6,
  marginBottom: 2,
};

export const scheduleCourseIconsStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  flexShrink: 0,
};

export const scheduleCourseRemoveBtnStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'none',
  border: 'none',
  padding: 2,
  cursor: 'pointer',
  color: COLOR.textMuted,
  borderRadius: 4,
  flexShrink: 0,
};

export const scheduleCourseMetaStyle: CSSProperties = {
  fontSize: 11,
  color: COLOR.textMuted,
  fontFamily,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
};

export const scheduleEmptyGradeStyle: CSSProperties = {
  border: `1px dashed ${COLOR.borderMedium}`,
  borderRadius: 8,
  padding: '14px 12px',
  textAlign: 'center',
  fontSize: 12,
  color: COLOR.textMuted,
  fontFamily,
};

export const scheduleNoCoursesStyle: CSSProperties = {
  padding: '24px 16px',
  textAlign: 'center',
  fontSize: 13,
  color: COLOR.textMuted,
  fontFamily,
  fontStyle: 'italic',
};

export const bottomBarStyle: CSSProperties = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: COLOR.white,
  borderTop: `1px solid ${COLOR.border}`,
  padding: '12px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  zIndex: 10,
};

export const returnBtnStyle: CSSProperties = {
  height: 36,
  paddingLeft: 12,
  paddingRight: 16,
  border: `1px solid ${COLOR.borderMedium}`,
  borderRadius: 4,
  backgroundColor: COLOR.white,
  color: '#00427C',
  fontFamily,
  fontSize: 14,
  fontWeight: 500,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
};

export const cancelBtnStyle: CSSProperties = {
  height: 36,
  paddingLeft: 16,
  paddingRight: 16,
  border: 'none',
  backgroundColor: 'transparent',
  color: COLOR.textSecondary,
  fontFamily,
  fontSize: 14,
  cursor: 'pointer',
};

export const gradeOptionHoverBg = '#F3F4F6';
export const addCourseBtnHoverBorder = '#999';
export const addCourseBtnHoverBg = '#F9FAFB';
export const removeCourseBtnHoverColor = '#DC2626';
export const courseNameReadOnlyColor = '#B45309';

export const gradePopoverBackdropStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 199,
};

export const courseCardContentStyle: CSSProperties = {
  padding: '12px 14px',
  display: 'flex',
  alignItems: 'center',
  gap: 10,
};

export const courseCardInfoStyle: CSSProperties = {
  flex: 1,
  minWidth: 0,
};

export const courseCardTitleButtonStyle: CSSProperties = {
  fontSize: 14,
  fontWeight: 500,
  color: COLOR.linkBlue,
  fontFamily,
  cursor: 'pointer',
  display: 'block',
  marginBottom: 2,
  background: 'none',
  border: 'none',
  padding: 0,
  textAlign: 'left',
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const courseCardMetaStyle: CSSProperties = {
  fontSize: 13,
  color: COLOR.textMuted,
  paddingLeft: 3,
  fontFamily,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const courseCardStatusTextStyle: CSSProperties = {
  fontSize: 12,
  color: courseNameReadOnlyColor,
  fontFamily,
  display: 'block',
};

export const courseCardActionsStyle: CSSProperties = {
  position: 'relative',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
};

export const gradeSelectorReadOnlyStyle: CSSProperties = {
  ...gradeSelectorBtnStyle,
  cursor: 'default',
};

export const courseCardExpandBtnStyle: CSSProperties = {
  background: 'none',
  border: `1px solid ${COLOR.borderMedium}`,
  borderRadius: 6,
  cursor: 'pointer',
  padding: '4px 6px',
  display: 'flex',
  alignItems: 'center',
  color: COLOR.textMuted,
  flexShrink: 0,
};

export const courseCardDescSectionStyle: CSSProperties = {
  borderTop: `1px solid ${COLOR.border}`,
  padding: '10px 14px 12px',
};

export const courseCardDescTextStyle: CSSProperties = {
  fontSize: 13,
  color: COLOR.textSecondary,
  fontFamily,
  lineHeight: 1.6,
  margin: 0,
};

export const groupCriteriaListStyle: CSSProperties = {
  margin: '10px 0 0',
  paddingLeft: 18,
  color: COLOR.textMuted,
  fontFamily,
  fontSize: 12,
  lineHeight: 1.5,
};

export const subjectFilterStyle: CSSProperties = {
  ...searchInputStyle,
  width: 170,
  paddingLeft: 10,
};

export const courseTypeFilterStyle: CSSProperties = {
  ...searchInputStyle,
  width: 170,
  paddingLeft: 10,
  height: 64,
};

export const gradeFilterStyle: CSSProperties = {
  ...searchInputStyle,
  width: 150,
  paddingLeft: 10,
};

export const noCoursesMatchStyle: CSSProperties = {
  fontSize: 13,
  color: COLOR.textMuted,
  fontFamily,
  padding: '8px 0',
};

export const choiceByGradeCardStyle: CSSProperties = {
  ...listCardStyle,
  overflow: 'visible',
  marginBottom: 16,
  padding: 24,
  gap: 24,
};

/** Group-of-courses card wrapper — conditional highlighted border when the group is selected. */
export const groupCardStyle = (isSelected: boolean): CSSProperties => ({
  ...listCardStyle,
  overflow: 'visible',
  marginBottom: 16,
  padding: 24,
  gap: 24,
  border: isSelected ? `2px solid ${COLOR.selectedCardBorder}` : `1px solid ${COLOR.border}`,
});

/** Body column for ChoicesByGradeCourses — no extra padding since the parent card already has padding: 24. */
export const cbgListBodyStyle: CSSProperties = {
  flex: 1,
  minWidth: 0,
};

export const choiceByGradeOptionBaseStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 10,
  padding: '10px 8px',
  borderRadius: 6,
  marginBottom: 8,
  cursor: 'pointer',
};

/**
 * Student add-subject flow variant: column layout so the description
 * panel expands below the top row instead of alongside it.
 */
export const cbgStudentOptionStyle = (isSelected: boolean): CSSProperties => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '12px',
  borderRadius: 8,
  marginBottom: 8,
  cursor: 'pointer',
  border: isSelected ? `2px solid ${COLOR.selectedCardBorder}` : `1px solid ${COLOR.border}`,
  backgroundColor: isSelected ? COLOR.selectedCardBg : COLOR.white,
});

/** Top row inside each student CBG radio card: radio + info block + expand chevron. */
export const choiceCardTopRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  width: '100%',
};

export const choiceByGradeInputStyle: CSSProperties = { marginTop: 3 };

export const choiceByGradeInfoWrapStyle: CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
};

export const choiceByGradeTitleStyle: CSSProperties = {
  fontSize: 14,
  fontWeight: 600,
  color: COLOR.linkBlue,
  fontFamily,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const choiceByGradeTitleBtnStyle: CSSProperties = {
  fontSize: 14,
  fontWeight: 600,
  color: COLOR.linkBlue,
  fontFamily,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  textAlign: 'left',
};

export const requirementHeadingStyle = (reqIndex: number): CSSProperties => ({
  fontSize: 15,
  fontWeight: 600,
  color: COLOR.textPrimary,
  fontFamily,
  marginBottom: 12,
  marginTop: reqIndex > 0 ? 24 : 0,
});

export const requirementCreditsHintStyle: CSSProperties = {
  fontWeight: 400,
  fontSize: 13,
  color: COLOR.textMuted,
  marginLeft: 8,
};

export const groupsOfCoursesOptionRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  marginBottom: 10,
  fontFamily,
  color: COLOR.textPrimary,
  fontSize: 14,
};

export const scheduleCreditFillStyle = (pct: number): CSSProperties => ({
  height: '100%',
  width: `${Math.min(pct, 100)}%`,
  backgroundColor: '#34D399',
  borderRadius: 4,
  transition: 'width 0.2s ease',
});

export const descriptionModalOverlayStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0,0,0,0.4)',
  zIndex: 300,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const descriptionModalCardStyle: CSSProperties = {
  backgroundColor: COLOR.white,
  borderRadius: 8,
  padding: 28,
  maxWidth: 480,
  width: '90%',
  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
};

export const descriptionModalTitleStyle: CSSProperties = {
  fontSize: 16,
  fontWeight: 700,
  color: COLOR.textPrimary,
  fontFamily,
  marginBottom: 12,
};

export const descriptionModalTextStyle: CSSProperties = {
  fontSize: 14,
  color: COLOR.textSecondary,
  fontFamily,
  lineHeight: 1.6,
  margin: 0,
};

export const descriptionModalCloseBtnStyle: CSSProperties = {
  marginTop: 20,
  padding: '8px 18px',
  backgroundColor: '#1162EE',
  color: COLOR.white,
  border: 'none',
  borderRadius: 4,
  fontSize: 14,
  fontFamily,
  cursor: 'pointer',
};

export const loadingPageStyle: CSSProperties = {
  ...pageStyle,
  alignItems: 'center',
  justifyContent: 'center',
};

export const loadingTextStyle: CSSProperties = {
  fontSize: 15,
  color: COLOR.textMuted,
  fontFamily,
};

export const loadErrorWrapStyle: CSSProperties = {
  padding: 32,
  fontSize: 14,
  color: '#DC2626',
  fontFamily,
};

export const loadErrorReturnBtnStyle: CSSProperties = {
  color: COLOR.linkBlue,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontFamily,
  fontSize: 14,
};

export const noRequirementsStyle: CSSProperties = {
  fontSize: 14,
  color: COLOR.textMuted,
  fontFamily,
  padding: '32px 0',
};

export const requirementSectionSpacing = (isLast: boolean): CSSProperties => ({
  marginBottom: isLast ? 0 : 32,
});

export const saveBtnStyle = (isDisabled: boolean): CSSProperties => ({
  height: 36,
  paddingLeft: 20,
  paddingRight: 20,
  border: 'none',
  borderRadius: 4,
  backgroundColor: isDisabled ? '#D1D5DB' : '#1162EE',
  color: isDisabled ? '#6B7280' : COLOR.white,
  fontFamily,
  fontSize: 14,
  fontWeight: 500,
  cursor: isDisabled ? 'not-allowed' : 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});

export const choiceByGradeOptionStyle = (isSelected: boolean): CSSProperties => ({
  ...choiceByGradeOptionBaseStyle,
  border: isSelected ? `1px solid ${COLOR.selectedCardBorder}` : `1px solid ${COLOR.border}`,
  backgroundColor: isSelected ? COLOR.selectedCardBg : COLOR.white,
});

export const blockInstructionStyle: CSSProperties = {
  margin: '0 0 16px',
  fontFamily,
  fontSize: 14,
  lineHeight: '20px',
  marginTop: '10px',
  color: COLOR.textSecondary,
};

export const blockDividerStyle: CSSProperties = {
  height: 1,
  backgroundColor: COLOR.border,
  margin: '18px 0',
};

export const mandatedInfoStyle: CSSProperties = {
  margin: 0,
  padding: '12px 0',
  fontFamily,
  fontSize: 14,
  lineHeight: '20px',
  color: COLOR.textSecondary,
};

export const mandatedCardStyle: CSSProperties = {
  ...listCardStyle,
  justifyContent: 'center',
  alignItems: 'center',
  padding: 24,
  minHeight: 160,
};

export const mandatedCardTextStyle: CSSProperties = {
  margin: 0,
  fontFamily,
  fontSize: 14,
  lineHeight: '20px',
  color: COLOR.textMuted,
  textAlign: 'center',
  maxWidth: 320,
};

export const subjectSelectedCountStyle: CSSProperties = {
  fontSize: 14,
  color: COLOR.textSecondary,
  fontFamily,
};

export const inPlanSectionLabelStyle: CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  color: COLOR.textMuted,
  fontFamily,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  padding: '8px 0 6px',
};

export const inPlanRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 10,
  padding: '10px 8px',
  borderRadius: 6,
  marginBottom: 8,
  border: `1px solid ${COLOR.border}`,
  backgroundColor: '#F9FAFB',
  opacity: 0.85,
  cursor: 'default',
};

export const inPlanStatusBadgeStyle = (status: string): CSSProperties => {
  // Normalize status so callers can pass either canonical (in-progress) or API-like variants.
  // This keeps mandated/read-only badges visually aligned with CBG and IFAL status behavior.
  const normalized = (status ?? '').toLowerCase();
  const isCompleted = normalized === 'completed' || normalized === 'complete';
  const isInProgress =
    normalized === 'in-progress' || normalized === 'in_progress' || normalized === 'in progress';
  const isFailed = normalized === 'failed' || normalized === 'incomplete';

  return {
    fontSize: 11,
    fontWeight: 500,
    fontFamily,
    color: isCompleted
      ? COLOR.inPlanCompletedText
      : isInProgress
        ? COLOR.inPlanInProgressText
        : isFailed
          ? COLOR.incompleteText
          : COLOR.textMuted,
    marginTop: 2,
  };
};

export const mandatedReadOnlyCourseRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 10,
  padding: '10px 8px',
  borderRadius: 6,
  marginBottom: 8,
  border: `1px solid ${COLOR.border}`,
  backgroundColor: COLOR.white,
};

// ─── Expandable radio card (choicesByGradeCourses) ───────────────────────────

/** Page-level sub-heading for the Choices by Grade section. */
export const cbgSubheadingStyle: CSSProperties = {
  margin: '0 0 20px',
  fontFamily,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
  color: COLOR.textSecondary,
};

/**
 * Wrapper for a section's instruction text when it is NOT preceded by another
 * section (i.e. it is the first or only visible section in the left column).
 */
export const sectionNoDividerWrapStyle: CSSProperties = {
  marginBottom: 16,
};

/**
 * Wrapper for a section's instruction text when it follows another section.
 * Renders a horizontal rule to visually separate consecutive course-type blocks,
 * matching the AllRulesExamplePage prototype pattern.
 */
export const sectionDividerWrapStyle: CSSProperties = {
  borderTop: '1px solid #777777',
  marginTop: 24,
  paddingTop: 24,
  marginBottom: 16,
};

/** Width-only sidebar for the Grade/Group/List label — outer card provides all padding. */
export const gradeLabelSidebarStyle: CSSProperties = {
  width: 96,
  flexShrink: 0,
};

export const gradeLabelStyle: CSSProperties = {
  fontSize: 15,
  fontWeight: 700,
  color: COLOR.textPrimary,
  fontFamily,
};

/** Sidebar for ItemsFromAList — same width as gradeLabelSidebarStyle so the body content aligns with grade body content. */
export const listItemSidebarStyle: CSSProperties = {
  width: 96,
  flexShrink: 0,
};

/** "Select N credits from this list of courses." paragraph in the IFAL sidebar. */
export const listCreditsLabelStyle: CSSProperties = {
  margin: '4px 0 0',
  fontSize: 13,
  color: COLOR.textMuted,
  fontFamily,
  lineHeight: 1.4,
};

/** Requirement criteria bullet list in the IFAL sidebar. */
export const ifalCriteriaListStyle: CSSProperties = {
  margin: '8px 0 0',
  paddingLeft: 16,
  fontSize: 13,
  color: COLOR.textMuted,
  fontFamily,
  lineHeight: 1.4,
};

export const choiceCardExpandBtnStyle: CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 4,
  color: COLOR.textMuted,
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  marginTop: -2,
};

export const choiceCardExpandIconStyle = (isExpanded: boolean): CSSProperties => ({
  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.15s ease',
  display: 'flex',
});

export const choiceCardDescDividerStyle: CSSProperties = {
  height: 1,
  backgroundColor: COLOR.border,
  margin: '0 12px',
};

export const choiceCardDescStyle: CSSProperties = {
  padding: '10px 12px',
  margin: 0,
  fontSize: 13,
  color: COLOR.textSecondary,
  fontFamily,
  lineHeight: 1.6,
};

/** Matches course-detail-drawer description fallback. */
export const choiceCardDescFallbackStyle: CSSProperties = {
  ...choiceCardDescStyle,
  fontStyle: 'italic',
};

/** Orange "Prerequisite needed" warning — pill badge (AC-14). */
export const choiceCardPrereqWarningStyle: CSSProperties = {
  display: 'inline-block',
  alignSelf: 'flex-start',
  marginTop: 4,
  fontSize: 12,
  fontFamily,
  padding: '3px 8px',
  borderRadius: 9999,
  backgroundColor: '#FEF9C3',
  color: '#713F12',
};

/** Blue "In progress" inline status chip shown next to course name in CBG cards. */
export const cbgInProgressBadgeStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  fontSize: 12,
  fontFamily,
  color: COLOR.inPlanInProgressText,
  flexShrink: 0,
};

/** Grade-awarded badge shown next to the status icon in schedule-preview rows. */
export const scheduleGradeAwardedStyle: CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: COLOR.completedText,
  fontFamily,
};
